import { ScriptType } from './types'

/**
 * Script configurations for third-party scripts
 *
 * Stability strategy:
 * - Script classification is managed in the Osano admin dashboard (URL-pattern rules),
 *   NOT via inline data-osano attributes. Osano monkey-patches setAttribute on script
 *   elements, so inline classification on dynamically created scripts causes crashes.
 * - We intentionally use lazyOnload to avoid race conditions with Next.js script insertion.
 * - Preconnect hints for cmp.osano.com remain in layout.tsx <head> to reduce connection latency.
 */
export const scriptConfigs: ScriptType[] = [
  {
    id: 'osano-embed-script',
    src: 'https://cmp.osano.com/169lRCSnpgboB57n9/7874d72b-af66-405b-a6c0-ed80501ec6e1/osano.js',
    strategy: 'lazyOnload',
    attributes: {
      crossOrigin: 'anonymous',
    },
  },
]
